import { createFileRoute } from "@tanstack/react-router";
import Integration from "@/components/Settings/Integration";

export const Route = createFileRoute("/_auth/innstillinger/integrasjon")({
  component: Integration,
  beforeLoad: () => ({
    getTitle: () => "Integrasjon",
  }),
});
